import SEO from '../components/SEO';
import HeroSection from '../components/home/HeroSection';
import BrandIntroSection from '../components/home/BrandIntroSection';
import CategoriesSection from '../components/home/CategoriesSection';
import ProcessSection from '../components/home/ProcessSection';
import ServicesSection from '../components/home/ServicesSection';
import ForBuyersSection from '../components/home/ForBuyersSection';
import WhyIndiaSection from '../components/home/WhyIndiaSection';
import WhyTaigaSection from '../components/home/WhyTaigaSection';
import CTASection from '../components/home/CTASection';

const HomePage = () => (
  <div className="pt-20" data-testid="home-page">
    <SEO
      title="Taiga Sourcing | Multi-Category Sourcing from India"
      description="Taiga Sourcing connects global buyers with Indian manufacturers. Source apparel, tiles, bathware, furniture, home decor, textiles, electrical, plumbing, chemicals and more from India."
      keywords="India sourcing company, India sourcing agent, India buying agent, source products from India, Indian manufacturers, India procurement partner, multi-category sourcing India"
      path="/"
    />
    <HeroSection />
    <BrandIntroSection />
    <CategoriesSection />
    <ProcessSection />
    <ServicesSection />
    <ForBuyersSection />
    <WhyIndiaSection />
    <WhyTaigaSection />
    <CTASection
      sectionTestId="request-sourcing-cta"
      linkTestId="sourcing-cta"
      bgClass="bg-[#fafaf9]"
      title="WHAT ARE YOU LOOKING TO SOURCE FROM INDIA?"
      titleClass="text-[#0B2A57]"
      description="Share your requirement with us. We'll help identify suitable Indian manufacturing options."
      descriptionClass="text-[#6B7280] max-w-2xl mx-auto"
      buttonClass="bg-[#0B2A57] text-white"
    />
    <CTASection
      sectionTestId="final-cta-section"
      linkTestId="final-cta"
      bgClass="bg-[#071E45]"
      title={<>YOUR REQUIREMENT.<br />OUR INDIA NETWORK.</>}
      titleClass="text-white"
      description="Let's build the right sourcing solution for your business."
      descriptionClass="text-white/60"
      buttonClass="bg-white text-[#0B2A57]"
    />
  </div>
);

export default HomePage;
